import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;
export default {
    ObtenerMenu(data) {
        return axios.post(`${domain.domainNameForApi}AsistenciaGeneral/ObtenerMenu`, data).then(response => response.data);
    },
    EncabezadoReporte(data) {
        return axios.post(`${domain.domainNameForApi}AsistenciaGeneral/EncabezadoReporte`, data).then(response => response.data);
    },
    ObtenerUrl(data) {
        return axios.post(`${domain.domainNameForApi}AsistenciaGeneral/ObtenerUrl`, data).then(response => response.data);
    },

}